import { render, staticRenderFns } from "./Pendant.vue?vue&type=template&id=2c6f1b4c&scoped=true&"
import script from "./Pendant.vue?vue&type=script&lang=js&"
export * from "./Pendant.vue?vue&type=script&lang=js&"
import style0 from "./Pendant.vue?vue&type=style&index=0&id=2c6f1b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f1b4c",
  null
  
)

component.options.__file = "Pendant.vue"
export default component.exports